module.exports = __webpack_public_path__ + "html/vehicle-detail.template.html";